import React, { useState, useEffect } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import config from "../../config";

function StudentCorrectionIX() {
  const navigate = useNavigate();

  const token = sessionStorage.getItem("secondaryAdminToken");
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");

  const [loading, setLoading] = useState(false);

  const [candidateId, setCandidateId] = useState("");
  const [schoolCode, setSchoolCode] = useState("");
  const [rollNo, setRollNo] = useState("");

  useEffect(() => {
    if (!permissions[9]?.caN_VIEW) {
      navigate("/secondary-admin-dashboard");
    }
  }, [permissions, navigate]);

  useEffect(() => {
    if (!token) {
      navigate("/secondary-admin");
    }
  }, [token, navigate]);

  // ---------------------------
  // Input Handlers
  // ---------------------------

  const handleCandidateChange = (e) => {
    const value = e.target.value.toUpperCase();
    setCandidateId(value);

    if (value) {
      setSchoolCode("");
      setRollNo("");
    }
  };

  const handleSchoolCodeChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setSchoolCode(value);

    if (value) {
      setCandidateId("");
    }
  };

  const handleRollNoChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setRollNo(value);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!candidateId && !schoolCode && rollNo) {
      Swal.fire({
        icon: "warning",
        title: "Please Enter School Code",
      });
      return;
    }
    if (!candidateId && schoolCode && !rollNo) {
      Swal.fire({
        icon: "warning",
        title: "Please Enter Roll No",
      });
      return;
    }
    if (!candidateId && !schoolCode) {
      Swal.fire({
        icon: "warning",
        title: "Please Enter Candidate ID OR School Code & Roll No",
      });
      return;
    }

    if (!schoolCode && !rollNo) {
      Swal.fire({
        icon: "warning",
        title: "Please Enter School Code & Roll No",
      });
      return;
    }

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Unauthorized",
        text: "Please login again.",
      });
      navigate("/secondary-admin");
      return;
    }

    setLoading(true);

    try {
      const requestBody = candidateId
        ? { candidatE_ID: candidateId, schooL_CODE: null, rolL_NO: null }
        : { schooL_CODE: schoolCode, rolL_NO: rollNo, candidatE_ID: null };

      const response = await fetch(
        `${config.API_BASE_URL}/AdminFetchStudentRegistrationCandidateID_CL9`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        },
      );

      const data = await response.json();

      if (response.ok && data?.data?.student_Data) {
        Swal.fire({
          icon: "success",
          title: "Student Found",
          timer: 1200,
          showConfirmButton: false,
        });

        navigate("/secondary-demographic-details-update-page-ix", {
          state: { studentData: data.data.student_Data },
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Not Found",
          text: data.message || "No student found with the given details.",
        });
      }
    } catch (err) {
      console.error("API Error:", err);
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleswapsubject = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${config.API_BASE_URL}/PreGenSubjectSwap`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Subject swap successfully completed.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data?.message || "Something went wrong.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "API call failed.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}

        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />

          <div className="main-panel">
            <div className="content-wrapper">
              {/* Header */}
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-university" /> Student Demographic
                      Details Correction for Class IX
                    </h1>

                    <ol className="breadcrumb">
                      <li>
                        <a
                          onClick={() => navigate("/secondary-admin-dashboard")}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className="fa fa-tachometer"
                            style={{ marginRight: 5 }}
                          ></i>
                          Home
                        </a>
                      </li>
                      <li className="active">
                        Student Correction for Class IX
                      </li>
                    </ol>
                  </section>
                </div>
              </div>

              {/* SEARCH SECTION */}
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <div className="row align-items-end">
                      {/* Candidate ID */}
                      <div className="col-md-3">
                        <label className="mb-2">Candidate ID</label>
                        <input
                          type="text"
                          className="form-control form-control-xs"
                          value={candidateId}
                          onChange={handleCandidateChange}
                          disabled={schoolCode !== "" || rollNo !== ""}
                          maxLength={20}
                        />
                      </div>
                      <div className="col-md-1 text-center">
                        <label className="mb-2">Or</label>
                      </div>
                      {/* School Code */}
                      <div className="col-md-2">
                        <label className="mb-2">School Code</label>
                        <input
                          type="text"
                          className="form-control form-control-xs"
                          value={schoolCode}
                          onChange={handleSchoolCodeChange}
                          disabled={candidateId !== ""}
                          maxLength={10}
                        />
                      </div>

                      {/* Roll No */}
                      <div className="col-md-2">
                        <label className="mb-2">Roll No</label>
                        <input
                          type="text"
                          className="form-control form-control-xs"
                          value={rollNo}
                          onChange={handleRollNoChange}
                          disabled={candidateId !== ""}
                          maxLength={10}
                        />
                      </div>

                      {/* Search Button */}
                      <div className="col-md-1">
                        <button
                          className="btn btn-primary"
                          style={{ marginTop: "10px" }}
                          onClick={handleSearch}
                        >
                          <i className="fa fa-search"></i> Search
                        </button>
                      </div>

                      {/* Swap Button */}
                      <div className="col-md-2">
                        <button
                          className="btn btn-success"
                          style={{ marginTop: "10px" }}
                          onClick={handleswapsubject}
                        >
                          <i className="fa fa-retweet"></i> Swap Subject
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentCorrectionIX;
